import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {DeviceConfigurationModel} from '../../../models/configuration/device-configuration.model';
import {WorkstationDevicesConfigurationModel} from '../../../models/configuration/workstation-devices-configuration.model';
import {EnumValidValueItemModel} from '../../../models/enum/enum-valid-value-item.model';
import {catchError} from 'rxjs/operators';
import {DocumentDataModel} from '../../../models/document/document-data.model';

@Injectable({
  providedIn: 'root'
})
export class DevicesService {

  constructor(private http: HttpClient) { }
  getDevices(locId: string): Observable<DeviceConfigurationModel[]> {
    return this.http.get<DeviceConfigurationModel[]>(`api/device-configuration/get-devices/${locId}`);
  }
  saveDevices(devices: DeviceConfigurationModel[]): Observable<DeviceConfigurationModel[]> {
    return this.http.post<DeviceConfigurationModel[]>('api/device-configuration/save-devices', devices);
  }
  getAttachedDevices(workstationId: string): Observable<any[]> {
    return this.http.get<any[]>(`api/device-configuration/get-attached-devices/${workstationId}`);
  }
  getWsDevice(wsDeviceId: string): Observable<WorkstationDevicesConfigurationModel[]> {
    return this.http.get<WorkstationDevicesConfigurationModel[]>(`api/device-configuration/get-workstation-device/${wsDeviceId}`);
  }
  getWsDeviceDefault(workstationId: string, deviceCategoryId: string): Observable<WorkstationDevicesConfigurationModel[]> {
    return this.http.get<WorkstationDevicesConfigurationModel[]>(`api/device-configuration/get-workstation-device-default/${deviceCategoryId}/${workstationId}`);
  }
  saveWsDevices(wsDevices: WorkstationDevicesConfigurationModel[]): Observable<WorkstationDevicesConfigurationModel[]> {
    return this.http.post<WorkstationDevicesConfigurationModel[]>('api/device-configuration/save-workstation-devices', wsDevices);
  }
  deleteWsDevice(wsDevice: any): Observable<any> {
    return this.http.post<WorkstationDevicesConfigurationModel>(`/api/device-configuration/delete-workstation-device`, wsDevice.model);
  }
  deleteDevice(device: any): Observable<any> {
    return this.http.post<DeviceConfigurationModel>(`/api/device-configuration/delete-device`, device);
  }
  isServerConnected(): Observable<any[]> {
    return this.http.get<any[]>(`api/device-configuration/isServerConnected`);
  }
  getWSId(locId: string, wsName: string): Observable<any> {
    return this.http.get<any>(`api/device-configuration/get-wsId/${locId}/${wsName}`);
  }
}
